const Update = () => {
  return (
    <div className='page update'>
    </div>
  );
};

export default Update;
